import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import StayInLoop from '../forms/stayInLoop';
import fetchDux from '../../state/fetch-dux';
import CookieLink from './CookieLink';

const WP_BASE = `${process.env.REACT_APP_WP_BASE}`;
const REACT_APP_SILVEROAK_LINK = `${process.env.REACT_APP_SILVEROAK_LINK}`;

const getAbsUrl = href => `${WP_BASE}${href}`;
const currentYear = new Date().getFullYear();

class Footer extends Component {
  render() {
    const {
      footerPromos,
      postStayInLoop,
      postStayInLoopError,
      postStayInLoopResult
    } = this.props;
    const {
      PROMO0
    } = footerPromos || {};
    const handlePostStayInLoop = values => {
      const payload = { ...values, source: 'Twomey.com - Footer' }
      postStayInLoop({ payload }, 'stay-in-loop-form');
    };

    return (
      <footer id="colophon" className="site-footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-xl-11 offset-xl-1">
                <a href="/" className="footer-wordmark">Twomey</a>
              </div>
              <div className="col-12 col-xl-4 offset-xl-1 col-lg-5 footer-form">
                {!postStayInLoopResult &&
                  <div>
                    <h3>Stay in the loop!</h3>
                    <p>
                      Get the latest scoop on events, new releases and special offers.
                    </p>
                    <StayInLoop
                      onSubmit={handlePostStayInLoop}
                      postError={postStayInLoopError}
                      result={postStayInLoopResult}
                    />
                  </div>}
                {postStayInLoopResult &&
                  <div>
                    <h3>Thank You!</h3>
                    <p>
                      We are excited you joined our mailing list.
                      You will now be able to hear more about our upcoming events and promotional offers!
                    </p>
                  </div>}
              </div>
              <div
                className="col-12 col-xl-5 offset-xl-1 col-lg-7 footer-promos"
                dangerouslySetInnerHTML={{
                  __html: PROMO0 || ''
                }}
              />
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <div className="row footer-addresses">
                  <div className="col-md-4 col-sm-6">
                    <h3>Twomey Russian River Valley</h3>
                    <address>
                      <a
                        href="https://goo.gl/maps/8kPnU45MQ5y71K2X7"
                        target="_blank"
                      >
                        3000 Westside Rd<br />
                        Healdsburg, CA 95448
                      </a>
                      <br />
                      <a href="tel:1(707) 942-7122" target="_blank">
                        (707) 942-7122
                      </a>
                    </address>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className="footer-links">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-10">
                  <div className="footer-links-inner">

                    <div className="footer-branding">
                      <a href="/" className="capsule">Twomey</a>
                      <CookieLink
                        href={`${REACT_APP_SILVEROAK_LINK}/`}
                        label="Silver Oak"
                        className="silver-oak"
                      />
                      <span>|</span>
                      <a href="https://www.twomey.com/" className="twomey">
                        Twomey
                      </a>
                      {' '}
                      <span>|</span>
                      <a
                        href="https://www.ovidnapavalley.com/"
                        className="ovid"
                      >
                        Ovid
                      </a>
                      {' '}
                      <span>|</span>
                      <a href="https://www.timeless.wine/" className="timeless">
                        Timeless
                      </a>
                    </div>

                    <div className="footer-social">
                      <a
                        href="https://instagram.com/twomeycellars"
                        aria-label="Instagram"
                        target="_blank"
                      >
                        <i className="fab fa-instagram" />
                      </a>
                      <a
                        href="https://www.facebook.com/TwomeyCellars"
                        aria-label="Facebook"
                        target="_blank"
                      >
                        <i className="fab fa-facebook-f" />
                      </a>
                      <a
                        href="https://twitter.com/twomey"
                        aria-label="Twitter"
                        target="_blank"
                      >
                        <i className="fab fa-twitter" />
                      </a>
                    </div>

                    <div className="footer-legal-links">
                      <a href="/">{`© Copyright ${currentYear} Twomey Cellars.`}</a>
                      <span>
                        <a href={getAbsUrl('/privacy/')}>Privacy & Terms</a>
                        <a href={getAbsUrl('/accessibility/')}>Accessibility</a>
                        <a href="https://silveroak.com/trade-and-press/">
                          Trade
                        </a>
                      </span>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

const mapState = state => {
  const { footerPromos } = state.wordpress || {};
  const {
    error: postStayInLoopError,
    result: postStayInLoopResult
  } = state.postStayInLoop.toJS();
  return {
    footerPromos,
    postStayInLoopError,
    postStayInLoopResult
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postStayInLoop: fetchDux.postStayInLoop.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(Footer);
